module.exports = __webpack_public_path__ + "img/rolex.a587f640.png";